export default __webpack_public_path__ + "static/media/people.6b942e00.svg";